const brands = [
    { image: 'images/frosmo_logo.png' }
];

export default brands;
